import React, { useState } from "react";
import { Container, Row, Col, Image, Pagination, Button } from "react-bootstrap";
import "../styles/menu.css";

const menuImages = [
  require("../assets/dist/img/m1.jpg"),
  require("../assets/dist/img/m2.jpg"),
];

const Menu = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showMenu, setShowMenu] = useState(false);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
<section className="menu-section">
  <Container className="text-center">
    <h1 className="menu-title">Nuestro menú</h1>

<Button
  className={`menu-show-btn ${showMenu ? "active" : ""}`}
  onClick={() => setShowMenu((prev) => !prev)}
>
  {showMenu ? "Ocultar menú" : "Ver menú"}
</Button>

    {showMenu && (
      <>
        <Pagination className="justify-content-center mt-4">
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {menuImages.map((_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}

          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === menuImages.length}
          />
        </Pagination>

        <Row className="justify-content-center mt-4">
          <Col md={8}>
            <Image
              src={menuImages[currentPage - 1]}
              alt={`Menú Página ${currentPage}`}
              fluid
              className="menu-image"
            />
          </Col>
        </Row>
      </>
    )}
  </Container>
</section>

  );
};

export default Menu;
